import EditFormPage from 'modules/ui/editform/EditFormPage';
import EditFormTextField from 'modules/ui/editform/fields/EditFormTextField';
import ParositasAdatlapEditService from 'app/admin/parositasadatlap/service/ParositasAdatlapEditService';
import EditFormSelectField from 'modules/ui/editform/fields/EditFormSelectField';
import EditFormGroupFields from 'modules/ui/editform/subForm/EditFormGroupFields';
import ExamImageField from 'app/admin/examImage/ExamImageField';
import nBossConnection from 'modules/base/service/nBossConnection';

const config = {
	key: 'parositasAdatlapEditForm',
	text: 'Parositas Adatlap',
	textKey: 'parositasadatlap',
	service: ParositasAdatlapEditService,
	icon: 'person',
	fields: [
		{
			key: 'pairing',
			text: 'Párosít',
			textKey: 'pairing',
			component: EditFormSelectField,
			required: true,
			items: () => ParositasAdatlapEditService.getPairingSelection()
		},
		{
			key: 'adatlapPath',
			text: 'Adatlap',
			textKey: 'adatlapPath',
			component: ExamImageField,
			imageUrl: `${nBossConnection.baseUrl}fmBrowserTableControl/getFileByPath?path=`,
			readOnly: true
		}
	]
};

function ParositasAdatlapEditForm() {
	return <EditFormPage config={config} />;
}

export default ParositasAdatlapEditForm;
